import OpenBetsView from './_open-bets-view.js'

export default {
  name: 'YourBetsController',
  values: {
    view: {
      configSet: OpenBetsView,
      configValues: {},
    },
    showSettledBetsTab: true,
    showSettledBetsOnBoarding: true,
  },
  meta: {
    extendable: false,
  },
}
